import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pinterest.icon",
  "use": "pinterest.icon-usage",
  "viewBox": "1620.203 -11083.74 11.595 14.904",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"1620.203 -11083.74 11.595 14.904\" id=\"pinterest.icon\"><g data-name=\"Group 8\"><path data-name=\"Path 20\" d=\"M35.766,35.4a4.058,4.058,0,0,1-2-.952c-.391,2.052-.869,4.019-2.285,5.046-.437-3.1.641-5.43,1.142-7.9-.854-1.438.1-4.331,1.9-3.618,2.217.877-1.919,5.346.857,5.9,2.9.583,4.082-5.03,2.285-6.856-2.6-2.636-7.561-.06-6.951,3.713.149.922,1.1,1.2.381,2.475-1.662-.368-2.158-1.679-2.095-3.427a5.6,5.6,0,0,1,5.047-5.142c3.131-.35,6.07,1.15,6.475,4.095.456,3.324-1.413,6.924-4.761,6.665Z\" transform=\"translate(1591.203 -11108.333)\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pinterest.icon.svg
// module id = gC2x
// module chunks = 13